import { Heading, Text, Image, VStack, HStack, AspectRatio, Box } from '@chakra-ui/react';

import ImageSrcError from '~/assets/images/ImageSrcError.png';

export type ItemInfoProps = {
  itemId: string;
  itemName: string;
  description: string;
  price: number;
  imageUrl: string;
  onNavigate?: () => void;
  onItemPositionChange?: () => void;
};

// category item
export default function Item({
  itemId,
  itemName,
  description,
  price,
  imageUrl,
  onNavigate,
  onItemPositionChange,
}: ItemInfoProps) {
  const handleClickItem = () => {
    onNavigate?.();
    onItemPositionChange?.();
  };

  const splitDescription = description.split('\n');
  return (
    <HStack
      justify="space-between"
      h={20}
      align="stretch"
      cursor="pointer"
      onClick={handleClickItem}
    >
      <VStack align="flex-start" spacing={0} flex="1">
        <Heading as="h4" fontSize="md" maxW="15rem" isTruncated>
          {itemName}
        </Heading>
        {splitDescription.length === 1 ? (
          <Text fontSize="xs" color="wsGray.500" flex={1} overflow="hidden">
            {splitDescription[0]}
          </Text>
        ) : (
          splitDescription.slice(0, 2).map((line) => (
            <Text
              fontSize="xs"
              color="wsGray.500"
              flex={1}
              overflow="hidden"
              key={line}
              noOfLines={1}
            >
              {line}
            </Text>
          ))
        )}
        <Text>NT${price}</Text>
      </VStack>
      {imageUrl ? (
        <AspectRatio w="80px" ratio={1}>
          <Image src={imageUrl} fallbackSrc={ImageSrcError} loading="lazy" borderRadius="base" />
        </AspectRatio>
      ) : (
        <Box w="80px" h="80px" />
      )}
    </HStack>
  );
}
